/**
 * Vale ou troca (F136, F306): o pedido do caixa, o do celular e a tela do
 * trocador perguntam a mesma coisa ao mesmo cliente — as mesmas palavras nos
 * três é o que faz o trocador reconhecer o pedido que chegou.
 */
export const EXCHANGE_KIND_TEXT = [
    {
        value: 'voucher',
        label: 'Vale',
        description: 'Devolve e fica com o valor para usar depois.',
    },
    {
        value: 'exchange',
        label: 'Troca',
        description: 'Devolve e leva outra peça agora.',
    },
];
//# sourceMappingURL=exchange.js.map